export const APPRoutes = {
    LOGIN: "/",
    MFA_VERIFICATION: "/MFA-verification",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    VALIDATION_EXPIRES: "/validation-expires",
    DASHBOARD: "/dashboard",
    CLIENTS: "/clients",
    SUBSCRIPTION_MANAGE_PLANS: "/subscription/manageplans",
    SUBSCRIPTION_SUBSCRIBERS: "/subscription/subscribers",
    SUBSCRIPTION_SUBSCRIBER_VIEW: "/subscription/subscribers/view/:id",
    SUBSCRIPTION_CREATE: "/subscription/create",
    SUBSCRIPTION_EDIT: "/subscription/edit/:id",
    SUBSCRIPTION_VIEW: "/subscription/view/:id",
    RESTRICTED: "/restricted",
    SERVICE_UNAVAILABLE: "/service-unavailable",
    SUBSCRIPTION_CONFIRAMTION: "Subscription/SubscriptionConfirmation/:id",
    CLIENTS_FORM: "/clients/form",
    CLIENTS_EDIT: "/clients/edit/:id",
    CLIENTS_VIEW: "/clients/view/:id",
    ORGANIZATIONS: "/organizations",
    ORGANIZATIONS_FORM: "/organizations/form",
    ORGANIZATIONS_EDIT: "/organizations/edit/:id",
    ORGANIZATIONS_VIEW: "/organizations/view/:id",
    LOCATIONS: "/locations",
    LOCATIONS_FORM: "/locations/form",
    LOCATIONS_EDIT: "/locations/edit/:id",
    LOCATIONS_VIEW: "/locations/view/:id",
    STAFFS: "/staffs",
    STAFFS_FORM: "/staffs/form",
    STAFFS_EDIT: "/staffs/edit/:id",
    STAFFS_VIEW: "/staffs/view/:id",
    AUDIT_LOGS: "/audit-logs",
    AUDIT_LOGS_VIEW: "/audit-logs/view/:id",
    ROLES: "/roles",
    ROLES_FORM: "/roles/form",
    ROLES_EDIT: "/roles/edit/:id",
    ROLES_VIEW: "/roles/view/:id",
    USERS: "/users",
    USERS_FORM: "/users/form",
    USERS_EDIT: "/users/edit/:id",
    USERS_VIEW: "/users/view/:id",
    PROVIDERS: "/providers",
    PROVIDERS_FORM: "/providers/form",
    PROVIDERS_EDIT: "/providers/edit/:id",
    PROVIDERS_VIEW: "/providers/view/:id",
    HEALTHCARE_PAYOR: "/healthcare-payor",
    HEALTHCARE_PAYOR_FORM: "/healthcare-payor/form",
    HEALTHCARE_PAYOR_EDIT: "/healthcare-payor/edit/:id",
    HEALTHCARE_PAYOR_VIEW: "/healthcare-payor/view/:id",
    CODING_AI: "/coding-ai",
    EMAIL_TEMPLATES: "/email-templates",
    EMAIL_TEMPLATES_FORM: "/email-templates/form",
    EMAIL_TEMPLATES_EDIT: "/email-templates/edit/:accountId",
    ANALYTICS: "/analytics",
    ANALYTICS_ORGANIZATIONS: "/analytics/organizations",
    ANALYTICS_ORGANIZATION_VIEW: "/analytics/organizations/view/:id",
    ANALYTICS_PATIENTS: "/analytics/patients",
    ANALYTICS_PATIENT_VIEW: "/analytics/patients/view/:organization_id/:facility_name",
    ANALYTICS_PRODUCTIVITY: "/analytics/productivity",
    ANALYTICS_PRODUCTIVITY_VIEW: "/analytics/productivity/view/:organization_id/:provider_name",
    ANALYTICS_REVENUE: "/analytics/revenue",
    ANALYTICS_REVENUE_VIEW: "/analytics/revenue/view/:organization_id",
    LOGIN_CREDS: "/login-creds",
    LOGIN_CREDS_FORM: "/login-creds/form",
    LOGIN_CREDS_EDIT: "/login-creds/edit/:id",
    LOGIN_CREDS_VIEW: "/login-creds/view/:id",
    REPORTS: "/reports",
    CREDENTIALING_TRACKING: "/credentialing/tracking",
    CREDENTIALING_TRACKING_FORM: "/credentialing/tracking/form",
    CREDENTIALING_TRACKING_EDIT: "/credentialing/tracking/edit/:id",
    CREDENTIALING_TRACKING_VIEW: "/credentialing/tracking/view/:id",
    INCENTIVE_RATES: "/incentive-rates",
    VALUE_BASED_CARE: "/value-based-care",
    VALUE_BASED_CARE_VIEW: "/value-based-care/view/:id",

    CLAIM_SUBMISSION: "/claim-submission",
    CLAIM_SUBMISSION_FORM: "/claim-submission/form",
    CLAIM_SUBMISSION_EDIT: "/claim-submission/edit/:id",
    CLAIM_SUBMISSION_VIEW: "/claim-submission/view/:id",

    CLAIM_STATUS: "/claim-status",
    CLAIM_STATUS_FORM: "/claim-status/form",
    CLAIM_STATUS_EDIT: "/claim-status/edit/:id",
    CLAIM_STATUS_VIEW: "/claim-status/view/:id",

    DENIAL_MANAGEMENT: "/denial-management",
    DENIAL_MANAGEMENT_VIEW: "/denial-management/view/:id/:claimIndex",

    ELIGIBILITY_VERIFICATION: "/eligibility-verification",
    ELIGIBILITY_VERIFICATION_FORM: "/eligibility-verification/form",
    ELIGIBILITY_VERIFICATION_EDIT: "/eligibility-verification/edit/:id",
    ELIGIBILITY_VERIFICATION_VIEW: "/eligibility-verification/view/:id",
    INSURANCE_LIST: "/claim-360/insurance-list",


    FEE_SCHEDULE_ANALYTICS: "/fee-schedule-analytics",
    FEE_SCHEDULE_ANALYTICS_VIEW: "/fee-schedule-analytics/view/:id",
    AEGIS_AI_DOCUMENTS: "/aegis-ai/documents",
    AEGIS_AI_DOCUMENTS_FORM: "/aegis-ai/documents/form",
    AEGIS_AI_DOCUMENTS_EDIT: "/aegis-ai/documents/edit/:id",
    AEGIS_AI_DOCUMENTS_VIEW: "/aegis-ai/documents/view/:id",
    AEGIS_AI_ASSIST: "/aegis-ai/assist",
    AEGIS_AI_ASSIST_FORM: "/aegis-ai/assist/form",
    AEGIS_AI_ASSIST_EDIT: "/aegis-ai/assist/edit/:id",
    AEGIS_AI_ASSIST_VIEW: "/aegis-ai/assist/view/:id",
    AEGIS_AI_CHAT: "/aegis-ai/chat",
    // Opened only inside Microsoft Teams, as the Aegis AI app's tab.
    TEAMS_CHAT: "/teams/chat",
}

